import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Snapshot } from 'types';

export const deleteThreshold = ({
  snapshotId,
  thresholdId,
}: {
  snapshotId: number;
  thresholdId: number;
}) => {
  return axios.delete(`/api/snapshots/${snapshotId}/thresholds/${thresholdId}`);
};

type UseDeleteThresholdOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof deleteThreshold>;
};

export const useDeleteThreshold = ({
  config,
  snapshotId,
}: UseDeleteThresholdOptions) => {
  return useMutation({
    onMutate: async (deletedThreshold) => {
      await queryClient.cancelQueries(['snapshot', snapshotId]);

      const previousSnapshot = queryClient.getQueryData<Snapshot>([
        'snapshot',
        snapshotId,
      ]);

      queryClient.setQueryData(['snapshot', snapshotId], {
        ...previousSnapshot,
        thresholds: previousSnapshot?.thresholds?.filter(
          (threshold) => threshold.id !== deletedThreshold.thresholdId
        ),
      });

      return previousSnapshot;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: deleteThreshold,
  });
};
